import { render } from "./Header.vue?vue&type=template&id=fdb7f4fe&scoped=true"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=fdb7f4fe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Zayd\\Documents\\Web Development\\Clients Projects\\RHDesigns\\rhdesigns-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb7f4fe"]])

export default __exports__